// src/pages/ComingSoon.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="cs-main">
        <div className="container">
          <div className="cs-card">
            <div className="cs-icon">
              <i className="fas fa-laptop-code"></i>
            </div>
            <h1 className="cs-title">Main Website Coming Soon</h1>
            <p className="cs-text">
              We're building a brand new experience. Our website will be live shortly.
              Thank you for your patience.
            </p>
            <div className="cs-buttons">
              <Link to="/" className="btn-primary">
                <i className="fas fa-home"></i> Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="cs-features">
        <div className="container">
          <div className="features-grid">
            <div className="feature">
              <i className="fas fa-palette"></i>
              <h3>Fresh Look</h3>
              <p>Modern & clean design</p>
            </div>
            <div className="feature">
              <i className="fas fa-tablet-alt"></i>
              <h3>Responsive</h3>
              <p>Works on all devices</p>
            </div>
            <div className="feature">
              <i className="fas fa-rocket"></i>
              <h3>Fast & Secure</h3>
              <p>Optimised performance</p>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default ComingSoon;